// 기본 레이아웃 및 컨테이너 스타일들
import styled from '@emotion/styled';
// 메인 컨테이너
export const ViewerContainer = styled.div`
  padding: var(--theme-spacing-lg);
  background-color: var(--my-card-background);
  border-radius: var(--theme-radius-md);
  box-shadow: var(--theme-shadow);

  @media (max-width: 640px) {
    padding: var(--theme-spacing-md);
  }
`;
// 강의 제목
export const LectureTitle = styled.h2`
  margin-top: 0;
  margin-bottom: var(--theme-spacing-lg);
  font-size: var(--theme-typography-font-size-xl);
  font-weight: var(--theme-typography-font-weight-bold);
  color: var(--theme-text);

  @media (max-width: 640px) {
    font-size: var(--theme-typography-font-size-lg);
    margin-bottom: var(--theme-spacing-md);
  }
`;
// 콘텐츠 영역
export const ContentArea = styled.div`
  margin-top: var(--theme-spacing-md);
  margin-bottom: var(--theme-spacing-xl);
  flex-grow: 1;

  @media (max-width: 640px) {
    margin-top: var(--theme-spacing-sm);
    margin-bottom: var(--theme-spacing-lg);
  }
`;
// 마크다운 컨테이너
export const MarkdownContainer = styled.div`
  container-type: inline-size;
  container-name: markdown-container;
  width: 100%;
  position: relative;
  font-family: var(--vscode-font-family, var(--theme-typography-font-family-sans));
`;
// 마크다운 래퍼
export const MarkdownWrapper = styled.div`
  line-height: 1.6;
  color: var(--vscode-editor-foreground, var(--theme-text));

  code:not(pre code) {
    background-color: var(--vscode-textCodeBlock-background, var(--theme-paper-light));
    padding: 0.2em 0.4em;
    border-radius: var(--theme-radius-sm);
    font-size: 0.9em;
    font-family: var(--vscode-editor-font-family, var(--theme-typography-font-family-mono));
    color: var(--vscode-textPreformat-foreground, var(--theme-text-secondary));

    html.dark &, body.vscode-dark & {
      background-color: var(--vscode-textCodeBlock-background, var(--theme-paper-dark));
      color:.vscode-textPreformat-foreground, var(--theme-text));
    }
  }
  pre {
    margin-bottom: 1em;
  }

  a {
    color: var(--vscode-textLink-foreground, var(--theme-primary));
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      color: var(--vscode-textLink-activeForeground, var(--theme-primary-dark));
    }
  }

  hr {
    border: 0;
    height: 1px;
    background-color: var(--vscode-editorWidget-border, var(--theme-border));
    margin: 1.5em 0;
  }

  max-width: 720px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 640px) {
    max-width: none;
    margin-left: 0;
    margin-right: 0;
  }
`;
// 강의 설명 섹션
export const LectureDescription = styled.div`
  margin-top: var(--theme-spacing-xl);
  padding-top: var(--theme-spacing-lg);
  border-top: 1px solid var(--theme-border-light);
  color: var(--theme-text-secondary);
  h3 {
    margin-top: 0;
    margin-bottom: var(--theme-spacing-md);
    font-size: var(--theme-typography-font-size-lg);
    font-weight: var(--theme-typography-font-weight-semibold);
    color: var(--theme-text);
  }
  p {
    line-height: 1.6;
    font-size: var(--theme-typography-font-size-sm);
  }

  @media (max-width: 640px) {
    margin-top: var(--theme-spacing-lg);
    padding-top: var(--theme-spacing-md);
  }
`;
// 퀴즈 및 코드 블록 래퍼
export const QuizWrapper = styled.div`
  container-type: inline-size;
  container-name: interactive-quiz-area;
  width: 100%;
`;
export const CodeBlockWrapper = styled.div`
  container-type: inline-size;
  container-name: code-block-area;
  width: 100%;
`;
// 카드 컨테이너 및 레이아웃
export const CardContainer = styled.div`
  border: 1px solid var(--theme-border);
  border-radius: var(--theme-radius-lg);
  box-shadow: var(--theme-shadow);
  margin-bottom: var(--theme-spacing-lg);
  overflow: hidden;
  background-color: var(--my-card-background);
`;
export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--theme-spacing-sm);
  padding: var(--theme-spacing-sm) var(--theme-spacing-md);
  background-color: var(--theme-paper-light);
  border-bottom: 1px solid var(--theme-border);
`;
export const SplitToggle = styled.button`
  min-height: 44px;
  padding: 0 var(--theme-spacing-sm);
  border: 1px solid var(--theme-border);
  border-radius: var(--theme-radius-sm);
  background: transparent;
  color: var(--theme-text);
  cursor: pointer;
  font-size: var(--theme-typography-font-size-sm);

  &[aria-pressed='true'] {
    background: var(--theme-paper-hover, var(--theme-primary-light));
    border-color: var(--theme-primary);
  }
`;
export const SplitGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--theme-spacing-md);

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;
export const SplitPane = styled.div`
  min-width: 0;
  max-height: 70vh;
  overflow: auto;
  overscroll-behavior: contain;
`;
export const GlossArticle = styled.article`
  padding: 16px 16px 48px;
  font-size: var(--theme-typography-font-size-sm);
  line-height: 1.6;
  color: var(--theme-text);

  p {
    margin: 0 0 0.9em;
  }

  dl {
    margin: 0 0 1.4em;
  }

  dl div {
    display: grid;
    grid-template-columns: minmax(4rem, 8rem) 1fr;
    gap: 8px 16px;
    margin: 0 0 0.45em;
  }

  dt {
    color: var(--theme-text-secondary);
    font-weight: 500;
  }

  dd {
    margin: 0;
  }

  small {
    display: block;
    margin-top: 16px;
    color: var(--theme-text-secondary);
    font-size: 12px;
  }
`;
export const LookupCard = styled.aside`
  position: absolute;
  z-index: 12;
  min-width: 220px;
  max-width: min(92vw, 360px);
  padding: 12px 32px 12px 14px;
  background: var(--my-card-background, #fff);
  color: var(--theme-text);
  border: 1px solid var(--theme-border);
  border-radius: var(--theme-radius-md);
  box-shadow: var(--theme-shadow);
  pointer-events: auto;
  cursor: pointer;

  strong {
    display: block;
    margin-bottom: 4px;
  }

  button {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 22px;
    height: 22px;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: inherit;
    cursor: pointer;
    font-size: 16px;
    line-height: 22px;
  }
`;
export const CardTitle = styled.h2`
  margin: 0;
  font-size: var(--theme-typography-font-size-lg);
  font-weight: var(--theme-typography-font-weight-semibold);
  color: var(--theme-text);
  flex-grow: 1;
  margin-right: var(--theme-spacing-sm);
`;
export const CardContent = styled.div`
  padding: var(--theme-spacing-lg);

  @media (max-width: 640px) {
    padding: var(--theme-spacing-md) var(--theme-spacing-xs);
  }
`;
export const StyledMarkdownH1 = styled.h1`
  margin-top: 1.5em;
  margin-bottom: 0.8em;
  font-weight: var(--theme-typography-font-weight-semibold);
  color: var(--vscode-editor-foreground, var(--theme-text));
  line-height: 1.3;
  font-size: clamp(1.25rem, 5vw, var(--theme-typography-font-size-xl));
  position: relative;
  padding-left: var(--theme-spacing-sm);
  margin-left: calc(-1 * var(--theme-spacing-sm));
  border-left: 3px solid transparent;
  transition: border-color var(--theme-transition-fast) ease-in-out;

  &:hover {
    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light));
  }

  @media (min-width: var(--theme-breakpoints-lg)) {
    font-size: var(--theme-typography-font-size-lg);
  }
`;
export const StyledMarkdownH2 = styled.h2`
  margin-top: 1.5em;
  margin-bottom: 0.8em;
  font-weight: var(--theme-typography-font-weight-semibold);
  color: var(--vscode-editor-foreground, var(--theme-text));
  line-height: 1.3;
  font-size: var(--theme-typography-font-size-lg);
  position: relative;
  padding-left: var(--theme-spacing-sm);
  margin-left: calc(-1 * var(--theme-spacing-sm));
  border-left: 3px solid transparent;
  transition: border-color var(--theme-transition-fast) ease-in-out;

  &:hover {
    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light));
  }

  @container markdown-container (min-width: 700px) {
    font-size: clamp(1rem, 2.5vw, 1.25rem);
  }
`;
export const StyledMarkdownH3 = styled.h3`
  margin-top: 1.5em;
  margin-bottom: 0.8em;
  font-weight: var(--theme-typography-font-weight-semibold);
  color: var(--vscode-editor-foreground, var(--theme-text));
  line-height: 1.3;
  font-size: var(--theme-typography-font-size-base);
  position: relative;
  padding-left: var(--theme-spacing-sm);
  margin-left: calc(-1 * var(--theme-spacing-sm));
  border-left: 3px solid transparent;
  transition: border-color var(--theme-transition-fast) ease-in-out;

  &:hover {
    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light));
  }

  @container markdown-container (min-width: 700px) {
    font-size: clamp(0.875rem, 2.0vw, 1rem);
  }
`;
export const StyledMarkdownP = styled.p`
  margin-bottom: 1em;
  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm));
  line-height: 1.6;
  color: var(--vscode-editor-foreground, var(--theme-text));
  position: relative;
  padding-left: var(--theme-spacing-sm);
  margin-left: calc(-1 * var(--theme-spacing-sm));
  border-left: 3px solid transparent;
  transition: border-color var(--theme-transition-fast) ease-in-out;

  &:hover {
    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light));
  }

  @media (max-width: 640px) {
    line-height: 1.5;
  }
`;
export const StyledUl = styled.ul`
  margin-bottom: 1em;
  padding-left: 1.5em;
`;
export const StyledOl = styled.ol`
  margin-bottom: 1em;
  padding-left: 1.5em;
`;
export const StyledLi = styled.li`
  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm));
  margin-bottom: 0.5em;
  line-height: 1.6;
  color: var(--vscode-editor-foreground, var(--theme-text));
  position: relative;
  padding-left: var(--theme-spacing-sm);
  margin-left: calc(-1 * var(--theme-spacing-sm));
  border-left: 3px solid transparent;
  transition: border-color var(--theme-transition-fast) ease-in-out;

  &:hover {
    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light));
  }

  @media (max-width: 640px) {
    line-height: 1.5;
  }
`;
export const StyledBlockquote = styled.blockquote`
  border-left: 4px solid var(--vscode-textSeparator-foreground, var(--theme-border));
  padding-left: var(--theme-spacing-md);
  margin: 1em 0;
  color: var(--vscode-descriptionForeground, var(--theme-text-secondary));
  background-color: var(--vscode-textBlockQuote-background, transparent);
  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm));
  position: relative;
  transition: background-color var(--theme-transition-fast) ease-in-out;

  &:hover {
    background-color: var(--vscode-editor-lineHighlightBackground, var(--theme-paper-hover));
  }

  p {
    font-size: inherit;
    margin-bottom: 0.5em;
    color: inherit;
  }
`;
export const StyledTable = styled.table`
  border-collapse: collapse;
  width: auto;
  max-width: 100%;
  margin-bottom: var(--theme-spacing-md);
  overflow-x: auto;
  display: block;
  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm));
  color: var(--vscode-editor-foreground, var(--theme-text));
  position: relative;
  padding-left: var(--theme-spacing-sm);
  margin-left: calc(-1 * var(--theme-spacing-sm));
  border-left: 3px solid transparent;
  transition: border-color var(--theme-transition-fast) ease-in-out;

  &:hover {
    border-left-color: var(--vscode-editor-lineHighlightBorder, var(--theme-primary-light));
  }

  @media (max-width: 640px) {
    font-size: var(--theme-typography-font-size-xs);
  }
`;
export const StyledTh = styled.th`
  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border));
  padding: var(--theme-spacing-xs) var(--theme-spacing-sm);
  text-align: left;
  background-color: var(--vscode-editorWidget-background, var(--theme-paper-light));
  font-weight: var(--theme-typography-font-weight-semibold);
  color: var(--vscode-editorWidget-foreground, var(--theme-text));

  @media (max-width: 640px) {
    padding: var(--theme-spacing-xxs) var(--theme-spacing-xs);
  }
`;
export const StyledTd = styled.td`
  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border));
  padding: var(--theme-spacing-xs) var(--theme-spacing-sm);
  text-align: left;
  color: var(--vscode-editor-foreground, var(--theme-text));

  @media (max-width: 640px) {
    padding: var(--theme-spacing-xxs) var(--theme-spacing-xs);
  }
`;
export const StyledAbbr = styled.abbr`
  &[title] {
    text-decoration: underline dotted;
    cursor: help;
  }
`;
